// extracted by mini-css-extract-plugin
export var disabled = "_1g-9";
export var error = "_1g-1";
export var fitContent = "_1g-a";
export var hasPrefix = "_1g-6";
export var hasSuffix = "_1g-4";
export var iconWrapper = "_1g-d";
export var infoIconWrapper = "_1g-g _1g-d";
export var input = "_1g-5";
export var inputWrapper = "_1g-0";
export var large = "_1g-8";
export var leadingIconWrapper = "_1g-e _1g-d";
export var measureBox = "_1g-h";
export var medium = "_1g-7";
export var prefix = "_1g-c";
export var readonly = "_1g-2";
export var small = "_1g-3";
export var suffix = "_1g-b";
export var trailingIconWrapper = "_1g-f _1g-d";